import { CONFIGURATIONS } from '@/utilities/configurations';

const MODES = ['production', 'staging', 'sandbox', 'development', 'test'];

export default class Configuration {
  mode = 'production';

  constructor(mode) {
    this.setMode(mode || 'production');
  }

  setMode(mode) {
    if (!MODES.includes(mode)) {
      throw new Error('Invalid mode: ' + mode);
    }

    this.mode = mode === 'test' ? 'staging' : mode;

    // const { saveEnvironmentToCookie } = useCookiesService();
    // saveEnvironmentToCookie(this.mode);

    return Object.assign(this, CONFIGURATIONS[this.mode]);
  }

  get isProduction() {
    return this.mode === 'production';
  }

  get isStaging() {
    return this.mode === 'staging';
  }

  get isSandbox() {
    return this.mode === 'sandbox';
  }
}
